import { render, staticRenderFns } from "./AddDelivery.vue?vue&type=template&id=136dcb6e&scoped=true&"
import script from "./AddDelivery.vue?vue&type=script&lang=js&"
export * from "./AddDelivery.vue?vue&type=script&lang=js&"
import style0 from "./AddDelivery.vue?vue&type=style&index=0&id=136dcb6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136dcb6e",
  null
  
)

export default component.exports